import { useState } from 'react'
import { Link } from 'react-router-dom'
import './Auth.css'

function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    // Handle forgot password logic
    console.log('Reset password for:', email)
    setSubmitted(true)
  }

  if (submitted) {
    return (
      <div className="auth-page auth-page-centered">
        <div className="auth-form-container">
          <Link to="/" className="auth-logo-centered">
            <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
              <rect width="40" height="40" rx="10" fill="url(#logo-gradient-forgot)"/>
              <path d="M12 20h16M20 12v16" stroke="white" strokeWidth="3" strokeLinecap="round"/>
              <defs>
                <linearGradient id="logo-gradient-forgot" x1="0" y1="0" x2="40" y2="40">
                  <stop stopColor="#7C3AED"/>
                  <stop offset="1" stopColor="#2563EB"/>
                </linearGradient>
              </defs>
            </svg>
            <span>Hubthrill</span>
          </Link>
          <div className="auth-form-wrapper">
            <div className="success-message">
              <div className="success-icon">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <h2>Check your email</h2>
              <p>We've sent a password reset link to <strong>{email}</strong></p>
              <p className="note">Didn't receive the email? Check your spam folder.</p>
              
              <div className="success-actions">
                <Link to="/login" className="btn-submit">Back to sign in</Link>
                <button onClick={() => setSubmitted(false)} className="btn-text">
                  Try a different email
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="auth-page auth-page-centered">
      <div className="auth-form-container">
        <Link to="/" className="auth-logo-centered">
          <svg width="32" height="32" viewBox="0 0 40 40" fill="none">
            <rect width="40" height="40" rx="10" fill="url(#logo-gradient-forgot2)"/>
            <path d="M12 20h16M20 12v16" stroke="white" strokeWidth="3" strokeLinecap="round"/>
            <defs>
              <linearGradient id="logo-gradient-forgot2" x1="0" y1="0" x2="40" y2="40">
                <stop stopColor="#7C3AED"/>
                <stop offset="1" stopColor="#2563EB"/>
              </linearGradient>
            </defs>
          </svg>
          <span>Hubthrill</span>
        </Link>
        <div className="auth-form-wrapper">
          <div className="auth-form-header">
            <h2>Reset password</h2>
            <p>Remember your password? <Link to="/login">Sign in</Link></p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>

            <button type="submit" className="btn-submit">
              Send reset link
            </button>
          </form>

          <p className="auth-footer">
            <Link to="/login">← Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
